<template>
  <div>
<!-- registered alert -->          
    <v-snackbar top v-model="showRegisteredMessage" color="green" class="pl-10">
          <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">The user has been added!</span>
    </v-snackbar>
    <!-- customer added alert -->          
    <v-snackbar top v-model="customerAddedMessage" color="green" class="pl-10">
          <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">The customer and the basebase have been created!</span>
    </v-snackbar>
<!-- exists alert -->
          <v-snackbar top v-model="exists" color="red" class="pl-10">
                <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">{{existMessage}}</span>
          </v-snackbar>
<!-- not allowed alert -->
          <v-snackbar top v-model="notAllowed" color="red" class="pl-10">
                <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">{{notAllowedMessage}}</span>
          </v-snackbar>
<!-- no valid domain alert -->
<v-snackbar top v-model="noValidDomainMessage" color="red" class="pl-10">
      <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">please provide a valid domain (e.g. test.de)!</span>
</v-snackbar>
    <v-row justify="center">
        <v-col cols='6'>
            <v-expansion-panels inset>
                <v-expansion-panel
                    v-for="(item,i) in 1"
                    :key="i"
                    >
                    <v-expansion-panel-header>
                      <v-row>
                           <v-img src="@/assets/user-illustration.svg" id="userimage"></v-img>
                          
                           <!-- <v-avatar color="#42DEFA" dark><v-icon dark class="mr-auto">mdi-account</v-icon></v-avatar>  -->
                            <span id="paneltitle" class="mt-5">Create User </span> 
                        
                      </v-row>
                        
                       

                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                    <div class="text-center">
                        <div class="my-2" />
                        <!-- <span class="existMessage">
                            {{existMessage}}
                        </span> -->
                        <form @submit.prevent="register" autocomplete="off">
                        <v-text-field
                            v-model="username"
                            color="secondary"
                            label="Name..."
                            prepend-icon="mdi-face"
                            required
                        />
                        <v-text-field
                            v-model="email"
                            color="secondary"
                            label="Email..."
                            type="email"
                            prepend-icon="mdi-email"
                            @blur="checkIfExists"
                            required
                        />
                        <v-text-field
                            v-model="password"
                            color="secondary"
                            type="password"
                            label="Password..."
                            prepend-icon="mdi-lock-outline"
                            required
                        />
                         <v-text-field
                            v-model="passwordCheck"
                            color="secondary"
                            type="password"
                            label="Confirm Password..."
                            prepend-icon="mdi-refresh"
                            required
                        />
                        <v-select
                            :items="companies"
                            v-model="company"
                            item-text="name"
                            item-value="company_id"
                            return-object
                            label="Company..."
                            prepend-icon="mdi-office-building-outline"
                        ></v-select>
                        <v-select
                            :items="groups"
                            v-model="group_id"
                            item-text="text"
                            item-value="value"
                            return-object
                            label="Group..."
                            prepend-icon="mdi-account-group"
                            class="mb-8"
                        ></v-select>
                        <v-btn color="primary" outlined type="submit" >
                            Create User
                        </v-btn>
                       
                        </form>
                        </div>                  
                
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                    
                    key=2
                    >
                    <v-expansion-panel-header>
                      <v-row>
                           <v-img src="@/assets/user-illustration.svg" id="userimage"></v-img>
                          
                           <!-- <v-avatar color="#42DEFA" dark><v-icon dark class="mr-auto">mdi-account</v-icon></v-avatar>  -->
                            <span id="paneltitle" class="mt-5">Create Customer</span> 
                        
                      </v-row>
                        
                       

                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                    <div class="text-center">
                        <div class="my-2" />
                        <!-- <span class="existMessage">
                            {{existMessage}}
                        </span> -->
                        <form @submit.prevent="addCustomer" autocomplete="off">
                        <v-text-field
                            v-model="customerName"
                            color="secondary"
                            label="Company..."
                            prepend-icon="mdi-face"
                            @blur="fillTextfields"
                            required
                        />
                        <v-text-field
                            v-model="domain"
                            color="secondary"
                            label="Domain (e.g. searchinsights.de)..."
                            @blur="fillTextfields"
                            prepend-icon="mdi-email"            
                        />
                       <v-select
                            :items="plans"
                            v-model="plan"
                            item-text="text"
                            item-value="value"
                            return-object
                            label="Plan..."
                            prepend-icon="mdi-account-group"
                        ></v-select>
                         <v-text-field
                            v-model="dbName"
                            color="secondary"
                            label="Database name..."
                            prepend-icon="mdi-refresh"
                            required
                        />
                         <v-text-field
                            v-model="dbUsername"
                            color="secondary"
                            label="Database username..."
                            prepend-icon="mdi-refresh"
                            required
                        />
                        <v-text-field
                            v-model="dockerName"
                            color="secondary"
                            label="Docker name..."
                            prepend-icon="mdi-refresh"
                            required
                        />
                        <v-text-field
                            v-model="port"
                            color="secondary"
                            label="Port..."
                            prepend-icon="mdi-refresh"
                            required
                        />
                        <v-btn color="primary" outlined type="submit" >
                            Create Customer &amp; Database
                        </v-btn>
                       
                        </form>
                        </div>                  
                
                  </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
       
    </v-row>
  </div>
</template>

<script>
export default {

    data: () => ({
      //database 
      customerName: "",
      domain: "",
      plans:[{value:0, text: 'O - Research & Monitoring'},{value:1, text: '1 - Research'}],
      plan: {value:1, text: '1 - Research'},
      dbName: "",
      dbUsername: "",
      dockerName: "",
      port: "",
      noValidDomainMessage: false,
      customerAddedMessage: false,



      companies: [],
      group_id: null,
      groups: [{value:0, text: 'O - Admin'},{value:1, text: '1 - User'} ],//o = admin , 1 = user
      company: '',
      username: "",
      email: "",
      password: "",
      passwordCheck: "",
      showRegisteredMessage: false,
      checkTerms: false,
      exists: false,
      existMessage: "",
      notAllowed: false,
      notAllowedMessage: "",
      auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
      sections: [
        {
          icon: 'mdi-chart-timeline-variant',
          iconColor: 'primary',
          title: 'Marketing',
          text: `We've created the marketing campaign of the website. It was a very interesting collaboration.`
        },
        {
          icon: 'mdi-code-tags',
          iconColor: 'secondary',
          title: 'Fully Coded in HTML5',
          text: `We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub.`
        },
        {
          icon: 'mdi-account-multiple',
          iconColor: 'cyan',
          title: 'Built Audience',
          text: 'There is also a Fully Customizable CMS Admin Dashboard for this product.'
        }
      ],
      socials: [
        {
          href: '#',
          icon: 'mdi-twitter',
          iconColor: '#1DA1F2'
        },
        {
          href: '#',
          icon: 'mdi-dribbble',
          iconColor: '#EA4C89'
        },
        {
          href: '#',
          icon: 'mdi-facebook',
          iconColor: '#3B5998'
        }
      ]
    }),
    methods: {
        addCustomer(){
          let dbObject = {
            customerName: this.customerName,
            domain: this.domain,
            plan: this.plan.value,
            dbUsername: this.dbUsername,
            dbName: this.dbName,
            dockerName: this.dockerName,
            port:  this.port
          }
          console.log(dbObject)
          this.$http.post(process.env.VUE_APP_APIURL+'/admin/server/db/create', dbObject, { headers: {'Authorization': this.auth}})
          .then(response =>{
          console.log(response)
            this.customerAddedMessage = true
            this.customerName = ""
            this.domain = ""
            this.dbUsername = ""
            this.dbName = ""
            this.dockerName = ""
            this.fetchPort()
            
          }).catch(error=>{
            
            
          })
        },

        fetchPort(){
          this.$http.get(process.env.VUE_APP_APIURL+'/admin/server/db/nextport', { headers: {'Authorization': this.auth}})
          .then(response =>{
              console.log(response.body)
              this.port = response.body
          }).catch(error=>{
              console.log(error)
          })
        },
        fillTextfields(){
          let name = ""
          
            try {
              if(this.domain.length > 0){
                let domainsplits = this.domain.split(".")
                if(domainsplits.length> 1){
                  name = domainsplits[0]
                }else{
                  this.noValidDomainMessage = true
                  this.domain = ""
                  let value = this.customerName.toLowerCase()
                  value = value.replace(/ä/g, 'ae');
                  value = value.replace(/ö/g, 'oe');
                  value = value.replace(/ü/g, 'ue');
                  value = value.replace(/ß/g, 'ss');
                  value = value.replace(/ /g, '-');
                  value = value.replace(/\./g, '');
                  value = value.replace(/,/g, '');
                  value = value.replace(/\(/g, '');
                  value = value.replace(/\)/g, '');
                  name = value
                }
              }else{
                  let value = this.customerName.toLowerCase()
                  value = value.replace(/ä/g, 'ae');
                  value = value.replace(/ö/g, 'oe');
                  value = value.replace(/ü/g, 'ue');
                  value = value.replace(/ß/g, 'ss');
                  value = value.replace(/ /g, '-');
                  value = value.replace(/\./g, '');
                  value = value.replace(/,/g, '');
                  value = value.replace(/\(/g, '');
                  value = value.replace(/\)/g, '');
                  name = value
              }
              
              
            } catch (error) {
              this.noValidDomainMessage = true
              this.domain = ""
            }

          this.dbName = name.replace(/-/g, '');
          this.dbUsername = "dbuser_"+ name.replace(/-/g, '');
          this.dockerName = "si-"+name+"-db"
        },
        fetchCompanies: function(){
            this.$http.get(process.env.VUE_APP_APIURL+'/company/mongoDatabases', { headers: {'Authorization': this.auth}})
                .then(response =>{
                    console.log(response.body)
                    this.companies = response.body
                }).catch(error=>{
                    console.log(error)
                })
        },
        register: function(){
          if(this.password == this.passwordCheck){
            // this.$matomo.trackEvent("Register", "register", "" , "" )
            let registerObject= {
              email: this.email,
              pass: this.password,
              username: this.username,
              company_id: this.company.company_id,
              group_id: this.group_id.value
            }
            this.$http.post(process.env.VUE_APP_APIURL+'/user/registerasadmin', registerObject, { headers: {'Authorization': this.auth}})
            .then(response =>{
            console.log(registerObject)
              if (response.body.registered == true) {

                this.showRegisteredMessage = true;
                //console.log(response)
                
              }
            }).catch(error=>{
              if(error.body.error.notallowed){
                // TODO: Website redirect
                this.notAllowed = true;
                this.notAllowedMessage = "This email adress is not allowed to register. Please contact us: contact@searchinsights.de";
              }else{
                //console.log(error)
              }
              
            })
          }else{
            this.existMessage = "The passwords do not match";
            this.exists=true;
            this.password = "";
            this.passwordCheck = "";
          }
        },
        checkIfExists: function(){
          let nameObject ={
            user: this.email
          }
            this.$http.post(process.env.VUE_APP_APIURL+'/user/namecheck', nameObject, { headers: {'Authorization': this.auth}})
            .then(function(response){
              if (response.body.register == false) {
                    this.existMessage = "That email already exists, please try something else";
                    this.exists = true;
                    this.email = "";
              }
            });
        }
    },
    mounted(){
        this.fetchCompanies();
        this.fetchPort()
    }
  }
</script>

<style scoped>
#userimage{
    margin-left: 5px;
    max-width: 60px !important;
}
#paneltitle{
    margin-left: 15px;
    font-size: 1.5em;
    padding-top: auto;
    padding-bottom: auto;
}
</style>